@if (shouldRender()) {
<section class="stats-block">
  <div class="stats-block__inner">

    <div class="stats-block__media">
      @if (backgroundImage()) {
        <img
          [ngSrc]="backgroundImage()"
          [alt]="backgroundAlt()"
          fill
          class="stats-block__image"
        />
      }
    </div>

    <div class="stats-block__content">
      @if (eyebrow()) {
        <span class="stats-block__label">{{ eyebrow() }}</span>
      }
      <h2 class="stats-block__heading">{{ title() }}</h2>
      @if (subtitle()) {
        <p class="stats-block__description">{{ subtitle() }}</p>
      }

      <dl class="stats-block__grid">
        @for (stat of stats(); track stat.label) {
          <div class="stats-block__stat">
            <dd class="stats-block__value" [countUp]="stat.display"></dd>
            <dt class="stats-block__stat-label">{{ stat.label }}</dt>
          </div>
        }
      </dl>
    </div>

  </div>
</section>
}
